import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { JudgeType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { JUDGES } from "../../utils/constants";

export const createJudge = async (data: JudgeType) => await post<JudgeType, string>(JUDGES, data);
export const updateJudge = async (data: JudgeType) => await put<JudgeType, string>(JUDGES, data);

export const getJudges = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${JUDGES}?${queryParams.toString()}`;
    return await get<PagedResultsType<JudgeType>>(url);
};

